import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { deactivateRoute, RouteDisabled } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useDisableRoute = (
  id: number,
  options: UseMutationOptions<RouteDisabled, unknown, void, unknown>
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () =>
      extractData(
        deactivateRoute({
          path: { id },
        })
      ),
    ...options,
    onSuccess(...args) {
      queryClient.invalidateQueries({
        queryKey: ['routes'],
      });
      options.onSuccess?.(...args);
    },
  });
};
